import React, { useCallback, useContext, useState } from 'react'
import { AuthContext } from '../../../../context/auth/auth-context'
import axios from 'axios'
import { IconButton, Tooltip } from '@mui/material'
import StopCircleIcon from '@mui/icons-material/StopCircle'
import { isEmptyString } from '../../../../utils/string-utils'
import ConfirmationModal from '../../../../components/modal/confirmation-modal'

export interface StrategyKillModalTriggerProps {
  strategyName: string
  isApiConnected: boolean
  controlKillUrl: string | null
}

const StrategyKillModalTrigger: React.FC<StrategyKillModalTriggerProps> = (props) => {
  const { strategyName, isApiConnected, controlKillUrl } = props
  const isDisabled = !isApiConnected || isEmptyString(controlKillUrl)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const openModal = useCallback((): void => {
    setIsModalOpen(true)
  }, [])
  const closeModal = useCallback((): void => {
    setIsModalOpen(false)
  }, [])

  const { accessToken } = useContext(AuthContext)

  const handleStrategyStop = useCallback((): void => {
    if (isEmptyString(controlKillUrl)) {
      console.error('[Strategy] No control api configured -- skipping')
      return
    }

    console.debug(`[Strategy] Stopping strategy: ${strategyName}`)

    if (controlKillUrl != null && controlKillUrl.length !== 0) {
      axios
        .post(controlKillUrl, null, { headers: { Authorization: `Bearer ${accessToken}` } })
        .then(response => {
          console.debug(response)
        })
        .catch(reason => {
          console.error(reason)
        })
    }
  }, [strategyName, controlKillUrl, accessToken])

  return (
    <>
      <ConfirmationModal
        open={isModalOpen}
        onClose={closeModal}
        onHandle={handleStrategyStop}
        title={`Stop "${strategyName}" strategy?`}
        description={'This action cannot be undone. Stop the strategy?'}
        handleButtonLabel={'Stop Strategy'}
        handleButtonColour={'error'}
      />

      <Tooltip title='Stop strategy'>
        <span>
          <IconButton color='error' size='small' disabled={isDisabled} onClick={openModal}>
            <StopCircleIcon/>
          </IconButton>
        </span>
      </Tooltip>
    </>
  )
}

export default React.memo(StrategyKillModalTrigger)
